import { render, staticRenderFns } from "./request_config.vue?vue&type=template&id=248d8b78"
import script from "./request_config.vue?vue&type=script&lang=js"
export * from "./request_config.vue?vue&type=script&lang=js"
import style0 from "./request_config.vue?vue&type=style&index=0&id=248d8b78&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports